var prot= 'https://'
var env= ''
var domain= '.onyxapis.com.br'

export default {
	API_KEY: 'ODNjYzEyYTVmY2M1',
	APP_ID: '83cc12a5fcc5',
	TIME_ALIVE_TRIGGER_API: 180000,
	META_API_LOCALSTORAGE: 'meta-api-recad',
	URL_ARQUIVOS: "https://storage3.onyxerp.com.br",
	URL_PROTOKOL_API: prot + 'protokol-api' + env + domain,
	URL_GOV_API: prot + 'gov-api' + env + domain,
	URL_AUTH_API: prot + 'auth-api' + env + domain,
	URL_JWT_API: prot + 'jwt-api' + env + domain,
	URL_META_API: prot + 'meta-api-v2' + env + domain,
	URL_ACCOUNT_API: prot + 'account-api' + env + domain,
	URL_ACCOUNT_API_V2: prot + 'account-api-v2' + env + domain,
	URL_SOCIAL_API: prot + 'social-api' + env + domain,
	URL_SOCIAL_API_V2: prot + 'social-api-v2' + env + domain,
	URL_STORAGE_API: prot + 'storage-api' + env + domain,
	URL_DEVICE_API: prot + 'device-api' + env + domain,
	URL_DASHBOARD_API: prot + 'dashboard-api' + env + domain,
	URL_BIOMETRIA_API: prot + 'biometria-api' + env + domain,
	URL_RECAD_API: prot + 'recad-api' + env + domain,
	URL_RECAD_API_V2: prot + 'recad-api-v2' + env + domain,
	URL_UFCIDADE_API: prot + 'ufcidade-api' + env + domain,
	URL_FOPAG_API: prot + 'fopag-api' + env + domain,
	URL_RH_API_V2: prot + 'rh-api-v2' + env + domain,
	OID_LOGIN_SEGURADO: "3a95c3e244e390e7ca8ced6d3abc0b", //Lagoa do Carro
	OEID_LOGIN_SEGURADO: "1e73401a17718bccbee052cfb23bd0", //LagoaPREV
	GTAG_ID: "G-FB0YEJPQCR",
	RE_CAPTCHA_S_KEY: "6LeEekYrAAAAAFBlePYU4jKTWG73SyqSt-I--DOA",
	Geolocalizacao: {
		"enableHighAccuracy": true,
		"timeout": 5000,
		"maximumAge": 0
	}
}



//////////////////
// WEBPACK FOOTER
// ./_doc/config-alpha.js
// module id = null
// module chunks = 